export default "__VITE_ASSET__CIYlY7iu__"